import { render, staticRenderFns } from "./task_edit.vue?vue&type=template&id=894e51a6&scoped=true"
import script from "./task_edit.vue?vue&type=script&lang=js"
export * from "./task_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894e51a6",
  null
  
)

export default component.exports